import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { fetchIncidentDetectionLapseReview } from "../../incidentDetectionLapseReview/logic/thunk";
import { selectIncidentDetectionLapseReviewStatus } from "../../incidentDetectionLapseReview/logic/slice";

import { CustomLoadingSpinner } from "../../../components/ui/spinners/LoadingSpinner";
import { ErrorDisplay } from "../../../components/ui/error/ErrorDisplay";
import { ControlReturnsForm } from "./ControlReturnsForm";

const ControlReturnsPage: React.FC = () => {
  const { id: caseId } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();

  const status = useAppSelector(selectIncidentDetectionLapseReviewStatus);

  useEffect(() => {
    if (caseId) {
      dispatch(fetchIncidentDetectionLapseReview(caseId));
    }
  }, [caseId, dispatch]);

  if (status === "loading" || status === "idle") {
    return (
      <div className="flex min-h-[700px] w-full items-center justify-center rounded-[14px] border border-gray-100 bg-white p-6 shadow-overviewCard">
        <CustomLoadingSpinner
          title="Loading control returns..."
          subtitle="Fetching control returns associated with this case."
          minHeight="min-h-0"
          className="m-0 border-0 bg-transparent shadow-none"
        />
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="flex min-h-[700px] w-full items-center justify-center rounded-[14px] border border-gray-100 bg-white p-6 shadow-overviewCard">
        <div className="w-[60vw] max-w-[800px]">
          <ErrorDisplay
            error="Unable to load control returns. Please try again."
            onRetry={() => caseId && dispatch(fetchIncidentDetectionLapseReview(caseId))}
          />
        </div>
      </div>
    );
  }

  return <ControlReturnsForm />;
};

export default ControlReturnsPage;
